import React, { useEffect } from "react";
import moment from "moment";
// Component
import Text from "../../../Components/FormControl/Text/Text";
import RadioBox from "../../../Components/FormControl/RadioBox/RadioBox";
import CheckBox from "../../../Components/FormControl/CheckBox/CheckBox";
import Date from "../../../Components/FormControl/Date/Date";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import TextArea from "../../../Components/FormControl/TextArea/TextArea";
import SwitchBox from "../../../Components/FormControl/SwitchBox/SwitchBox";
import { useCoupon } from "../../../Context/CouponCurd/useCoupon";
import MultiSelectNew from "../../../Components/MultiSelectNew";

//IMAGES
import DeleteIcon from "../../../Assets/images/delete.svg";

//css
import styles from "./index.module.scss";
import { convertDateTime } from "Helpers/date";
import { convertUtcTimestampToPstDate } from "Hooks/commanUtility";
import { storeList } from "api/stores";
import { VALUELESS_COUPON_TYPES } from "../../../Helpers/Constants";

const TypeAndValue = (props) => {
  const [errorMessage, setErrorMessage] = React.useState("");
  const [storeSelectionOptions, setStoreSelectionOptions] = React.useState([]);

  const {
    couponState,
    setIsGlobalCoupon,
    setCouponDescription,
    setStoreSelection,
  } = useCoupon();

  useEffect(() => {
    // fetch the store list from the api to prepare the options for the store selection
    const fetchStoreList = async () => {
      const response = await storeList();
      if (response.status === 200) {
        if (response?.data?.data?.rows?.length > 0) {
          const options =
            response?.data?.data?.rows?.map((store) => ({
              label: store.title,
              value: store.id,
              store_id: store.id,
              id: null,
            })) || [];
          setStoreSelectionOptions(options);
        } else {
          setStoreSelectionOptions([]);
        }
      }
    };
    fetchStoreList();
  }, []);

  const handleInputChange = (data) => {
    props.setCouponApplyTo(data);
    props.emptySelectedData();
    setErrorMessage("");
  };

  const handleInputChangeType = (data) => {
    props.setCouponCodeType(data);
  };

  const handleSetSelectedCategoryData = (SelectedData) => {
    let duplicateData = props.couponState.coupons_specific_collections?.filter(
      (data) => {
        if (
          data.category_hierarchy_id === SelectedData[0].category_hierarchy_id
        ) {
          return data;
        }
      }
    );

    if (duplicateData && duplicateData.length > 0) {
      setErrorMessage("This Category is already added");
    } else {
      setErrorMessage("");
      props.setSelectedData(SelectedData[0]);
    }
  };

  const handleSetSelectedProductData = (SelectedData) => {
    let duplicateData = props.couponState.coupons_specific_collections?.filter(
      (data) => {
        if (data.id === SelectedData[0].id) {
          return data;
        }
      }
    );

    if (duplicateData && duplicateData.length > 0) {
      setErrorMessage("This Product is already added");
    } else {
      setErrorMessage("");
      props.setSelectedData(SelectedData[0]);
    }
  };

  return (
    <div id="MainContent" className="main-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <TextArea
              label="Coupon Description"
              value={couponState.coupon_description}
              onChange={(data) => setCouponDescription(data)}
              id="coupon_description"
            />
          </div>
        </div>
        <h3 className="bold mt-5 mb-3 d-flex ">
          <span>Type</span>
        </h3>
        <div className="row d-flex ">
          <div className={`col-6 d-flex`}>
            <div className={`col-4 pl-1`}>
              <RadioBox
                label="Percentage"
                labelClass={styles.RadioLabel}
                value="Percentage"
                required={true}
                selectedValue={props.couponState.coupon_type}
                onChange={(data) => {
                  handleInputChangeType(data);
                }}
                disabled={false}
              />
            </div>
            <div className={`col-6`}>
              <RadioBox
                label="Fixed Amount"
                labelClass={styles.RadioLabel}
                value="Fixed Amount"
                selectedValue={props.couponState.coupon_type}
                onChange={(data) => {
                  handleInputChangeType(data);
                }}
                disabled={false}
              />
            </div>
            <div className={`col-6`}>
              <RadioBox
                label="Free Add-On"
                labelClass={styles.RadioLabel}
                value="Free Add-On"
                selectedValue={props.couponState.coupon_type}
                onChange={(data) => {
                  handleInputChangeType(data);
                }}
                disabled={false}
              />
            </div>
            <div className={`col-6`}>
              <RadioBox
                label="Free Delivery"
                labelClass={styles.RadioLabel}
                value="Free Delivery"
                selectedValue={props.couponState.coupon_type}
                onChange={(data) => {
                  handleInputChangeType(data);
                }}
                disabled={false}
              />
            </div>
            <div className={`col-6`}>
              <RadioBox
                label="Free Size Upgrade"
                labelClass={styles.RadioLabel}
                value="Free Size Upgrade"
                selectedValue={props.couponState.coupon_type}
                onChange={(data) => {
                  handleInputChangeType(data);
                }}
                disabled={false}
              />
            </div>
          </div>
          {props.couponState.coupon_type === "Free Delivery" && (
            <div className={`col-12 text-left`}>
              <p style={{ color: "hsl(0, 0%, 40%)", fontSize: "13px", margin: "0 0 12px" }}>
                Covers the cheapest delivery option the customer is shown at that
                store, and only that option. A customer who picks a pricier one pays
                the full delivery charge. Not valid on store pickup or multi-address
                orders.
              </p>
            </div>
          )}
          <div className={`col-6 text-left d-flex`}>
            <div className="col-4">
              <h4 style={{ color: "hsl(0, 0%, 50%)" }}>Global Code</h4>
              <SwitchBox
                value={couponState.is_global_coupon}
                required={true}
                submitStatus={props.submitStatus}
                onChange={(data) => {
                  setIsGlobalCoupon(data);
                  if (data) {
                    setStoreSelection([]);
                  }
                }}
                id="is_global_coupon"
              />
            </div>
            {!couponState.is_global_coupon && (
              <div className="col-8">
                <MultiSelectNew
                  options={storeSelectionOptions}
                  value={couponState.coupon_assign_stores}
                  isDisabled={false}
                  placeholder={"Select Store Locations"}
                  onChange={(data) => {
                    setStoreSelection(data);
                    setIsGlobalCoupon(false);
                  }}
                  isClearable={false}
                  tooltipId="store-selection-tooltip"
                  maxItemsToShow={2}
                  showEllipsis={false}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {!VALUELESS_COUPON_TYPES.includes(props.couponState.coupon_type) && (
        <div className="container-fluid">
          <h3 className="bold mt-5 mb-3 d-flex align-items-center">
            <span>Value</span>
          </h3>
          <div className="row">
            <div className={`col-12 col-mb-12`}>
              <Text
                type="text"
                label="Coupon Value"
                value={props.couponState.coupon_value}
                submitStatus={props.submitStatus}
                required={true}
                disabled={false}
                onChange={(data) => {
                  if (!/^[0-9]*$/.test(data) || data.length > 8) {
                    return;
                  }
                  let val = (+data).toString() || "0";
                  props.setCouponCodeValue(val);
                }}
                id="coupon_value"
                maxlength={8}
              />
            </div>
          </div>
        </div>
      )}
      <div className="container-fluid">
        <h3 className="bold mt-5 mb-3 d-flex align-items-center">
          <span>Apply To</span>
        </h3>
        <div className="row ml-1">
          <div className={`col-mb-3`}>
            {/* comment on 22-07-2021 as told by mem */}
          </div>
          <div className={`col-mb-3`}>
            <RadioBox
              label="Specific Product"
              labelClass={styles.RadioLabel}
              value="Specific Product"
              required={true}
              selectedValue={props.couponState.coupon_apply_to}
              onChange={(data) => {
                handleInputChange(data);
              }}
              disabled={false}
            />
          </div>
          <div className={`col-mb-3`}>
            <RadioBox
              label="Order Total"
              labelClass={styles.RadioLabel}
              value="Order Total"
              required={true}
              selectedValue={props.couponState.coupon_apply_to}
              onChange={(data) => {
                handleInputChange(data);
              }}
              disabled={false}
            />
          </div>
        </div>
        <div className="row ml-1">
          <div className={`col-mb-3`}>
            <CheckBox
              label="Is redeemable only on mobile app orders?"
              value={props.couponState.coupon_redeem_for_mobile}
              required={false}
              submitStatus={props.submitStatus}
              onChange={(data) => props.setCouponRedeemForMobile(data)}
              id="coupon_redeem_for_mobile"
            />
          </div>
        </div>
      </div>

      {props.couponState.coupon_apply_to !== "Order Total" ? (
        <div className={`row`}>
          <div className={`col-md-12`}>
            {props.couponState.coupon_apply_to === "Specific Collection" ? (
              <Autocomplete
                id="categorySearching"
                className="auto-select"
                freeSolo
                options={props.categoryList.map((option) => option.title)}
                renderInput={(params) => (
                  <TextField {...params} label="Search Category" />
                )}
                onInputChange={(event, newValue) => {
                  event.preventDefault();
                  if (newValue !== undefined) {
                    let filterData = props.categoryList?.filter((data) => {
                      if (data.title === newValue) {
                        return data;
                      }
                    });
                    if (
                      filterData !== undefined &&
                      filterData !== null &&
                      filterData.length > 0
                    ) {
                      handleSetSelectedCategoryData(filterData);
                    }
                  }
                }}
              />
            ) : (
              <Autocomplete
                id="productSearching"
                className="auto-select"
                freeSolo
                options={props.productsList.map((option) => option.title)}
                renderInput={(params) => (
                  <TextField {...params} label="Search Product" />
                )}
                onInputChange={(event, newValue) => {
                  event.preventDefault();
                  if (newValue !== undefined) {
                    let filterData = props.productsList?.filter((data) => {
                      if (data.title === newValue) {
                        return data;
                      }
                    });
                    if (
                      filterData !== undefined &&
                      filterData !== null &&
                      filterData.length > 0
                    ) {
                      handleSetSelectedProductData(filterData);
                    }
                  }
                }}
              />
            )}
            {errorMessage !== "" ? (
              <p className={styles.paragraphBackground}>{errorMessage}</p>
            ) : (
              ""
            )}
          </div>
          <div className={`col-md-12`}>
            <div className="table-responsive mt-2 mb-4">
              <table className="table">
                <tbody>
                  {props.couponState.coupons_specific_collections &&
                  props.couponState.coupons_specific_collections.length > 0 ? (
                    props.couponState.coupons_specific_collections?.map(
                      (d, i) => {
                        return (
                          <tr id={i}>
                            {props.couponState.coupon_apply_to ===
                            "Specific Collection" ? (
                              <td className={``}>
                                {d.category_image !== "" ? (
                                  <div className={styles.ProductImageWrapper}>
                                    <img src={d.category_image} alt={d.title} />
                                  </div>
                                ) : (
                                  <div className={`${styles.emptyImage}`}>
                                    <span>Image</span>
                                  </div>
                                )}
                              </td>
                            ) : (
                              <td className={``}>
                                {d.product_images[0]?.image !== "" ? (
                                  <div className={styles.ProductImageWrapper}>
                                    <img
                                      src={d.product_images[0]?.image}
                                      alt={d.title}
                                    />
                                  </div>
                                ) : (
                                  <div className={`${styles.emptyImage}`}>
                                    <span>Image</span>
                                  </div>
                                )}
                              </td>
                            )}
                            <td className={``}>{d.title}</td>
                            <td className={`link cursor-pointer`}>
                              <img
                                onClick={(e) => props.deleteSelectedData(i)}
                                className={`${styles.searchIcon} mr-3`}
                                src={DeleteIcon}
                                alt=""
                              />
                            </td>
                          </tr>
                        );
                      }
                    )
                  ) : (
                    <tr>
                      <td className={``}>
                        <div className={`${styles.emptyImage}`}>
                          <span>Image</span>
                        </div>
                      </td>
                      <td className={``}>No Data</td>
                      <td className={` text-center`}>-</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="container-fluid">
        <h3 className="bold mt-5 mb-3 d-flex align-items-center">
          <span>Usage Limits</span>
        </h3>
        <div className="row">
          <div className={`col-md-6`}>
            <CheckBox
              label="Limit to one use per customer"
              value={props.couponState.usage_limit_one_per_user}
              required={false}
              submitStatus={props.submitStatus}
              onChange={(data) => props.setUsageLimitPerUser(data)}
              id="usage_limit_one_per_user"
            />
          </div>
          <div className={`col-md-6`}>
            <Text
              type="text"
              label="Max Coupon Use Limit"
              value={props.couponState.usage_limit_number_of_time}
              submitStatus={props.submitStatus}
              required={true}
              disabled={false}
              onChange={(data) => {
                if (!/^[0-9]*$/.test(data) || data.length > 10) {
                  return;
                }
                let val = data.toString() || "";
                props.setCouponUseCount(val);
              }}
              id="total_coupon_use"
            />
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <h3 className="bold mt-5 mb-3 d-flex align-items-center">
          <span>Active Dates</span>
        </h3>
        <div className="row">
          <div className={`col-md-6`}>
            <Date
              type="dateTime"
              label="State Date"
              value={
                props.startDate !== ""
                  ? convertUtcTimestampToPstDate(
                      props.startDate,
                      "ccc LLLL d, yyyy hh:mm a"
                    )
                  : ""
              }
              dateFormat="ddd LL"
              timeFormat="hh:mm A"
              onChange={(data) => {
                let pst = moment(data).format("ddd LL hh:mm A");

                let timestamp = convertDateTime(
                  pst,
                  "format5",
                  "ccc LLLL d, yyyy hh:mm a"
                );

                props.setStartDate(timestamp);
              }}
              id="start_date"
              checkPassDate={true}
            />
          </div>
          <div className={`col-md-6`}>
            <Date
              label="End Date(Optional)"
              value={
                props.endDate !== "" && props.endDate !== 0
                  ? convertUtcTimestampToPstDate(
                      props.endDate,
                      "ccc LLLL d, yyyy hh:mm a"
                    )
                  : ""
              }
              dateFormat="ddd LL"
              timeFormat="hh:mm A"
              type="dateTime"
              onChange={(endDate) => {
                let pst = moment(endDate).format("ddd LL hh:mm A");
                let timestamp = convertDateTime(
                  pst,
                  "format5",
                  "ccc LLLL d, yyyy hh:mm a"
                );

                props.setEndDate(timestamp);
              }}
              id="end_date"
              checkPassDate={true}
            />
          </div>
        </div>
      </div>
      <span
        data-dismiss="modal"
        onClick={(e) => props.handleSubmitClick(e)}
        className="btn gray-btn d-inline-block mt-5 mb-3 mr-2"
        style={{ marginLeft: "280px" }}
      >
        Save
      </span>
    </div>
  );
};
export default TypeAndValue;
